var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "top-btn" },
        [
          _c(
            "vxe-button",
            { attrs: { status: "success" }, on: { click: _vm.returnToLevel } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
      _c(
        "a-form",
        {
          attrs: {
            "label-algin": "left",
            "label-col": { style: { width: "160px" } },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "经销商名称:" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.org_id_text,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "org_id_text", $$v)
                          },
                          expression: "form.org_id_text",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "申请人:" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.sq_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sq_name", $$v)
                          },
                          expression: "form.sq_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "申请类型:" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.sq_type_text,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sq_type_text", $$v)
                          },
                          expression: "form.sq_type_text",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "申请时间:" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.cdate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cdate", $$v)
                          },
                          expression: "form.cdate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "送货地址:",
                        "label-col": { style: { width: "125px" } },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.sh_address,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sh_address", $$v)
                          },
                          expression: "form.sh_address",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "收货人联系电话:" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.sh_phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sh_phone", $$v)
                          },
                          expression: "form.sh_phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "邮编:" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.sh_zip,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sh_zip", $$v)
                          },
                          expression: "form.sh_zip",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "使用用途:",
                        "label-col": { style: { width: "125px" } },
                      },
                    },
                    [
                      _c("a-textarea", {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.usage,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "usage", $$v)
                          },
                          expression: "form.usage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "发货单号:",
                        "label-col": { style: { width: "125px" } },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.rel_inv_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "rel_inv_code", $$v)
                          },
                          expression: "form.rel_inv_code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 6 } }),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { staticStyle: { "margin-left": "-9px" }, attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "物料种类是否符合:",
                        "label-col": { style: { width: "190px" } },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.type_accord,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "type_accord", $$v)
                          },
                          expression: "form.type_accord",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "物料数量是否符合:",
                        "label-col": { style: { width: "190px" } },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.amount_accord,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "amount_accord", $$v)
                          },
                          expression: "form.amount_accord",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "签收时间:",
                        "label-col": { style: { width: "180px" } },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.signed_time,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "signed_time", $$v)
                          },
                          expression: "form.signed_time",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "签收人签名:" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: "", placeholder: "" },
                        model: {
                          value: _vm.form.mt_signed,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mt_signed", $$v)
                          },
                          expression: "form.mt_signed",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("h5", [
        _vm._v(
          "物料信息列表[(申请)支付金额合计:" +
            _vm._s(_vm.sqcostNum) +
            "元; (审批)支付金额合计:" +
            _vm._s(_vm.spcostNum) +
            "元]"
        ),
      ]),
      _c(
        "div",
        { staticStyle: { "margin-top": "30px" } },
        [
          _c(
            "vxe-table",
            {
              attrs: {
                loading: _vm.listLoading,
                border: "",
                resizable: "",
                height: "300",
                align: _vm.allAlign,
                data: _vm.tableData,
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "seq", width: "60", title: "序号" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "mt_name", title: "物料名称" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "inventory", width: "100", title: "库存量" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "cost", width: "100", title: "物料单价" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "sq_amount", width: "100", title: "申请数量" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "sqcost", title: "（申请）支付金额" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "sp_amount", width: "100", title: "审批数量" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "spcost", title: "(审批)支付金额" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "ss_amount", width: "100", title: "实收数量" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "30px" } },
        [
          _c(
            "vxe-table",
            {
              attrs: {
                loading: _vm.listLoading,
                border: "",
                resizable: "",
                height: "300",
                align: _vm.allAlign,
                data: _vm.tableDataAuditList,
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "seq", width: "60", title: "序号" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "user_name", width: "200", title: "审核人" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "audit_time", width: "200", title: "审核日期" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "audit_idear", title: "意见" },
              }),
              _c("vxe-table-column", {
                attrs: { field: "status_name", width: "100", title: "状态" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }